import type { KeyboardEvent } from "react";

type GuidedCareCardProps = {
  imageSrc: string;
  title: string;
  linkText: string;
  linkHref: string;
  alt?: string;
  onSelect?: () => void;
  isArabic?: boolean;
};

export default function GuidedCareCard({
  imageSrc,
  title,
  linkText,
  linkHref,
  alt = "",
  onSelect,
  isArabic,
}: GuidedCareCardProps) {
  const handleKeyDown = (event: KeyboardEvent<HTMLElement>) => {
    if (!onSelect) return;
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onSelect();
    }
  };

  return (
    <article
      className={`w-full max-w-[360px] p-4 flex flex-col justify-center items-center gap-4 bg-white border border-[#EBEBEB] rounded-xl ${
        onSelect ? "cursor-pointer transition-shadow hover:shadow-lg" : ""
      }`}
      role={onSelect ? "button" : undefined}
      tabIndex={onSelect ? 0 : undefined}
      onClick={onSelect}
      onKeyDown={handleKeyDown}
      style={{ boxShadow: "0px 4px 14px rgba(0, 0, 0, 0.06)" }}
    >
      <img src={imageSrc} alt={alt} className="w-[60px] h-[60px] mx-auto" />

      <p className="text-[14px] text-center text-[#2B2B2B] leading-[17px]">
        {title}
      </p>

      <a
        href={linkHref}
        onClick={(event) => {
          if (onSelect) {
            event.preventDefault();
            event.stopPropagation();
            onSelect();
            return;
          }
          event.stopPropagation();
        }}
        className="text-[#4242CE] text-[12px] flex items-center justify-center gap-2"
      >
        {linkText}
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={!isArabic ? "rotate-0" : "rotate-180"}
        >
          <path
            d="M0.5 4H7.5M7.5 4L4 0.5M7.5 4L4 7.5"
            stroke="#4242CE"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </a>
    </article>
  );
}
